/**
 * HandlebarsHelpers
 *
 * @namespace APP
 * @name APP.HandlebarsHelpers
 */
APP.HandlebarsHelpers = (/** @lends APP.HandlebarsHelpers */function () {
	'use strict';

	var exports;

	/**
	 * Initialize HandlebarsHelpers
	 *
	 * @inner
	 * @public
	 * @memberof APP.HandlebarsHelpers
	 * @returns {void}
	 */
	function init() {
		initHandlebarsHelpers();
	}

	/**
	 * Initialize Handlebars helpers
	 *
	 * @inner
	 * @public
	 * @memberof APP.HandlebarsHelpers
	 * @returns {void}
	 */
	function initHandlebarsHelpers() {

		Handlebars.registerHelper('toLowerCase', function (str) {
			return str.toLowerCase();
		});

		Handlebars.registerHelper('eq', function (v1, v2, options) {
			if (v1 === v2) {
				return options.fn(this);
			}
			return options.inverse(this);
		});

		Handlebars.registerHelper('isEqual', function (v1, v2) {
			return v1 === v2;
		});

		Handlebars.registerHelper('noteq', function (v1, v2, options) {
			if (v1 !== v2) {
				return options.fn(this);
			}
			return options.inverse(this);
		});

		Handlebars.registerHelper('json', function (json) {
			return JSON.stringify(json);
		});

		Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {

			switch (operator) {
				case '==':
					return v1 === v2 ? options.fn(this) : options.inverse(this);
				case '===':
					return v1 === v2 ? options.fn(this) : options.inverse(this);
				case '<':
					return v1 < v2 ? options.fn(this) : options.inverse(this);
				case '<=':
					return v1 <= v2 ? options.fn(this) : options.inverse(this);
				case '>':
					return v1 > v2 ? options.fn(this) : options.inverse(this);
				case '>=':
					return v1 >= v2 ? options.fn(this) : options.inverse(this);
				case '&&':
					return v1 && v2 ? options.fn(this) : options.inverse(this);
				case '||':
					return v1 || v2 ? options.fn(this) : options.inverse(this);
				default:
					return options.inverse(this);
			}
		});

	}

	exports = {
		init: init
	};

	/* test-code */
	/* eslint no-underscore-dangle: 0 */
	exports.__testonly__ = {};
	/* end-test-code */

	return exports;

}());
